import React from 'react';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import { Link } from 'fw/components/formatter/Formatter';
import * as App from 'modules/app/App';

class BusinessTypesSDVOBLink extends React.Component {
	handleClick = (e) => {
		e.stopPropagation();
		return false;
	}

	shouldComponentUpdate(nextProps) {
		return nextProps.value !== this.props.value;
	}

	onExportData = () => {
		const rq = {
			isSDVob: true,
			statusCode: this.props.dependentValues.certificationStatusDescription
		};

		if (App.hasPrivilege("ExecutiveReportSummarySearch")) {
			new API().post(APIModules.Admin.url('/dashboard/getBusinessTypesExport', rq), rq,
				{
					success: (sr) => {
						new API().download(sr.data);
					}
				});
		}
	}

	_getSearchQueueLinkValue() {
		return {
			url: `/admin/searchQueue?showAll=true&certificationStatusCode=APL&disabledVobStatus=SDVOB`,
			title: this.props.value ? this.props.value : 0
		};
	}

	_getConnectVOBLinkValue() {
		let statusCode = this.props.dependentValues.certificationStatusDescription === "Certified" ? "CER" :
			this.props.dependentValues.certificationStatusDescription === "Expired" ? "EXP" : "";

		return {
			url: `/admin/connectToVOB?certificationStatusCode=${statusCode}&disabledVobStatus=True`,
			title: this.props.value ? this.props.value : 0
		};
	}

	render() {
		const row = this.props.dependentValues;
		const centerAlignStyle = { display: "block", textAlign: "center" };

		// Empty cell with background for special rows (Prequals, Total SD/VOB)
		if (row.isSpecialRow) {
			const bgColor = row.certificationStatusDescription === "Prequals" ? "#f0f0f0" : "#e0e0e0";
			return (
				<div style={{ backgroundColor: bgColor, marginLeft: "-8px", marginRight: "-8px", height: "35px" }}></div>
			);
		}

		// TOTALS row - just show the number as plain text
		if (row.certificationStatusDescription === "TOTALS") {
			return (
				<span style={centerAlignStyle}>{this.props.value}</span>
			);
		}

		// Applications - link to search queue
		if (row.certificationStatusDescription === "Applications") {
			return (
				<Link value={this._getSearchQueueLinkValue()} style={centerAlignStyle}></Link>
			);
		}

		// Decertified - just show the number as plain text
		if (row.certificationStatusDescription === "Decertified") {
			return (
				<span style={centerAlignStyle}>{this.props.value}</span>
			);
		}

		// Certified/Expired - link to connectToVOB (if not zero)
		const value = this.props.value ? this.props.value : 0;
		if (value === 0 || value === "0") {
			return (
				<span style={centerAlignStyle}>{value}</span>
			);
		}
		return (
			<Link value={this._getConnectVOBLinkValue()} style={centerAlignStyle}></Link>
		);
	}
}

export default BusinessTypesSDVOBLink;



// WEBPACK FOOTER //
// ./src/areas/shared/components/formatter/BusinessTypesSDVOBLink.js